import React from 'react';
import BlogSearch from './BlogSearch';
import BlogRecentPosts from './BlogRecentPosts';

function BlogWidgetsContainer() {
    return (
        <>
            <ul className="widget widget-container">
                <BlogSearch />
                <BlogRecentPosts />
            </ul>
        </>
    );
}

export default BlogWidgetsContainer;
